import React from "react";
import "./adminHeader.css"; // optional styling

const AdminHeader = ({ username = "User" }) => {
  return (
    <div className="admin-header">
      <h3>Hello, {username}</h3>
    </div>
  );
};

export default AdminHeader;
